import { Translate } from 'react-redux-i18n'

export const TranslateCompany = ({ count }) => (
  <Translate
    value={`library.filterCompanies.${
      !count || count < 2 ? 'COMPANY' : 'COMPANIES'
    }`}
    count={count}
  />
)

export const TranslateRemoveMultiCompany = ({ count, portfolioName }) => (
  <Translate
    value={`library.detailsPortfolios.TEXT_DELETE_MULTI_COMPANY${
      count < 2 ? '2' : ''
    }`}
    count={count}
    portfolioName={portfolioName}
    dangerousHTML
  />
)

export const TranslateAddCompany = ({ name, count }) => (
  <Translate
    value={`library.detailsPortfolios.TEXT_ADD_COMPANY${count < 2 ? '2' : ''}`}
    name={name}
    count={count}
    dangerousHTML
  />
)
